module.exports = __webpack_public_path__ + "media/images/person-04b3c46871aca8903f122a05c0a9ab72.png";